import { defineMessages } from 'react-intl';

export default defineMessages({
  minutes: {
    id: 'components.CircularProgress.minutes',
    defaultMessage: 'min',
  },
});
